import { actionCreatorFactory } from 'typescript-fsa';
import { ClientSymbolFilter } from '@cbridge-packages/symbol-client';

export namespace SymbolMappingFilterAction {
  const actionCreator = actionCreatorFactory('SymbolMappingFilter');

  export const clearFilter = actionCreator('CLEAR_FILTER');
  export const setFilter = actionCreator<ClientSymbolFilter>('SET_FILTER');

  export const destroy = actionCreator('DESTROY');
}
